<template>
  <q-panel
    class="q-form-container clearfix"
    :header-text="formStructure.caption"
  >
<!--    <q-form-->
<!--      v-if="formStructure.generateElements"-->
<!--      :ref="formStructure.key"-->
<!--      :model="model"-->
<!--      label-width="120px"-->
<!--    >-->
<!--      <q-form-generator-->
<!--        v-model="model"-->
<!--        :form-structure="formStructure"-->
<!--      />-->
<!--    </q-form>-->
    <component
      :is="formStructure.staticFormKey"
      v-model="model"
      :form-structure="formStructure"
    />

<!--    <div-->
<!--      v-if="formStructure.generateElements"-->
<!--      slot="footer"-->
<!--    >-->
<!--      <q-button-->
<!--        type="primary"-->
<!--        @click="run"-->
<!--      >-->
<!--        <span>{{ $qt('model.okButtonText') }}</span>-->
<!--      </q-button>-->
<!--    </div>-->
  </q-panel>
</template>

<script>
  import "./index";
  import Vue from "vue";
  import caller from "../../q-components/q-caller";
  import reportMixin from "./models/reportMixin";

  export default {
    name: "QDashboardForm",

    components: Vue.prototype.$forms,

    mixins: [reportMixin],
    props: {
      structureKey: {type: String, required: true},
    },

    data() {
      return {
        title: "-",
        formStructure: {},
        model: {},
      };
    },

    computed: {},

    methods: {

      initialize(data) {
        this.formStructure = data.formStructure;

        this.$eventHub.$emit("onPageChanging", {
          caption: this.formStructure.caption,
          note: this.formStructure.note,
        });
      },
    },

    beforeRouteEnter(to, from, next) {
      caller.delegate('structure', 'fetchFormStructure', {
        structureKey: to.params.structureKey
      }).then((res1) => {
        let structure = res1.result;
        next(vm => vm.initialize({
          formStructure: structure,
        }));
      }).catch(() => {
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.$delegate('structure', 'fetchFormStructure', {
        structureKey: to.params.structureKey
      }).then((res1) => {
        let structure = res1.result;
        this.initialize({
          formStructure: structure,
        });
        next();
      }).catch(() => {
      });
    },
  };
</script>

<style scoped>
    .q-form-container {
        padding: 10px;
    }
</style>